<template>
  <section role="main" class="content-body">
    <header class="page-header">
      <h2>各項申請/消滅作業</h2>
      <div class="right-wrapper">
        <ol class="breadcrumbs">
          <li>
            <a href="/">
              <i class="fa fa-home"></i>
            </a>
          </li>
          <li><span>各項申請/消滅作業</span></li>
        </ol>
      </div>
    </header>
    <!-- start: page -->
    <div id="tabs-02" class="row">
      <div id="tabs-03" class="row">
        <div class="col-md-12">
          <section class="panel">
            <header class="panel-heading">
              <h2 class="panel-title">各項申請/消滅作業</h2>
            </header>
            <div class="panel-body">
              <table class="table table-no-more table-bordered table-striped mb-none">
                <thead>
                  <tr>
                    <th class="text-center" width="34%">作業名稱</th>
                    <th class="text-center" width="33%">匯出</th>
                    <th class="text-center" width="33%">匯入</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td data-title="作業名稱" class="text-center">緩徵申請</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_1_1')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_1_1')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_1_1')" class="popup-with-zoom-anim btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                  <tr>
                    <td data-title="作業名稱" class="text-center">緩徵延長修業</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_1_2')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_1_2')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_1_2')" class="popup-with-zoom-anim btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                  <tr>
                    <td data-title="作業名稱" class="text-center">緩徵消滅</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_1_cancel')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_1_cancel')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_1_cancel')" class="popup-with-zoom-anim btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                  <tr>
                    <td data-title="作業名稱" class="text-center">儘後召集申請</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_2_1')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_2_1')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_2_1')" class="popup-with-zoom-anim btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                  <tr>
                    <td data-title="作業名稱" class="text-center">儘後召集延長修業</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_2_2')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_2_2')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_2_2')" class="popup-with-zoom-anim btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                  <tr>
                    <td data-title="作業名稱" class="text-center">儘後召集消滅</td>
                    <td data-title="匯出" class="text-center">
                      <a href="#" @click.prevent="exportFile('Excel', 'apply_2_cancel')" class="btn-upload btn btn-warning">匯出EXCEL</a>
                      <a href="#" @click.prevent="exportFile('Csv', 'apply_2_cancel')" class="btn-upload btn btn-warning">匯出CSV</a>
                    </td>
                    <td data-title="匯入" class="text-center"><a href="#" @click.prevent="importFile('apply_2_cancel')" class="btn-upload btn btn-warning">匯入資料</a></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </section>
        </div>
      </div>
    </div>
    <div id="small-dialog" class="dialog zoom-anim-dialog mfp-hide">
      <div class="row">
        <div class="col-md-36">
          <section class="panel" style="padding: 0 25px;">
            <div class="table-responsive">
              <h4 style="font-weight: bold; display: inline-block; margin-right: 10px;">{{typeName}}-匯入資料</h4>
              <div style="display: inline-block;">
                <a :href="'/bursary/files/' + typeName + '_範例.xlsx'">《匯入檔範例》</a>
              </div>
              <div style="display: -webkit-inline-box;">上傳匯入檔案：<input ref="file" type="file"></div>
              <br>
              <div align="center">
                <a href="#" @click.prevent="formSubmit" class="btn-upload btn btn-primary" style="background-color:#337AB7; border-color:#2E6DA4;">送出</a>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  data() {
    return {
      form: {
        file: null,
        type: null
      },
    };
  },
  computed: {
    typeName() {
      switch (this.form.type) {
        case "apply_1_1": return "緩徵申請";
        case "apply_1_2": return "緩徵延長修業";
        case "apply_1_cancel": return "緩徵消滅";
        case "apply_2_1": return "儘後召集申請";
        case "apply_2_2": return "儘後召集延長修業";
        case "apply_2_cancel": return "儘後召集消滅";
      }
      return "";
    }
  },
  methods: {
    exportFile(fileType, type) {
      this.$http
        .post(
          "/api/MilitaryExport/" + fileType + "/" + type,
          {},
          { responseType: "arraybuffer" }
        )
        .then((res) => {
          this.download2File(res);
        });
    },
    importFile(type) {
      this.form.type = type;
      $.magnificPopup.open(
        {
          items: { src: "#small-dialog" },
          type: "inline",
          fixedContentPos: false,
          fixedBgPos: true,
          overflowY: "auto",
          closeBtnInside: true,
          preloader: false,
          midClick: true,
          removalDelay: 300,
          mainClass: "my-mfp-zoom-in",
        },
        0
      );
    },
    formSubmit() {
      if (this.checkForm() == false) return;
      let formData = new FormData();
      formData.append("file", this.form.file);
      formData.append("type", this.form.type);
      this.$http
        .post("/api/militaryImport", formData, {
          headers: { "Content-Type": "multipart/form-data" },
        })
        .then((a) => {
          if (a.body.status) {
            if (a.body.msg) {
              alert(a.body.msg);
            } else {
              alert(this.form.type + " 匯入成功");
            }
            this.$refs.file.value = null;
            $.magnificPopup.close();
          } else {
            alert(a.body.msg);
            console.log(a.body.exstr);
          }
        });
    },
    checkForm() {
      this.form.file = this.$refs.file.files[0];
      if (
        this.form.file === undefined ||
        this.form.file.type !==
          "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      ) {
        alert("請上傳EXCEL檔(xlsx)");
        return false;
      }
    },
  },
};
</script>

<style>
</style>